
import React, { useContext } from 'react'
// import GetsalesFields from './GetsalesFields'
import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import SimpleDateField from '../../Custom/CustomInput/SimpleDateField'
import { validateInputField } from '../../Utility/Utility.js'
import SearchFieldsContext from '../context/context'

const SalesFilter = () => {
    // const SearchFields = useContext(SearchFieldsContext)
    const { searchFields, setSearchFields } = useContext(SearchFieldsContext)

    function handleChange(e) {

        const { id, value } = e.target
        const i = searchFields.salesFields.findIndex(x => x.propId === e.target.getAttribute('data-propid'))
        const newSearchFields = searchFields
        const maxInputValue = newSearchFields.salesFields[i].maxInputValue ? newSearchFields.salesFields[i].maxInputValue : ''

        const newValue = newSearchFields.salesFields[i].type === 'date' ? value : validateInputField(value, newSearchFields.salesFields[i].type, maxInputValue)
        if (newSearchFields.salesFields[i].type === 'date') {
            newSearchFields.salesFields[i] = id.indexOf('start') !== -1 ? { ...newSearchFields.salesFields[i], startValue: newValue } : { ...newSearchFields.salesFields[i], endValue: newValue }
        } else {
            newSearchFields.salesFields[i] = id.indexOf('min') !== -1 ? { ...newSearchFields.salesFields[i], minValue: newValue } : { ...newSearchFields.salesFields[i], maxValue: newValue }
        }
        setSearchFields({ ...newSearchFields })
    }

    return (
        <>
            <div className="flex flex-col gap-2">
                {searchFields ?
                    searchFields.salesFields.map(value => {
                        return (
                            <>
                                <div className="text-2">
                                    <label>{value.label}</label>
                                </div>
                                <div className="mb-3">
                                    {value.type === 'date' ?
                                        <div className="flex flex-row space-x-2 sm:space-x-4">
                                            <SimpleDateField propid={value.propId} testid={`Start-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYY' : ''} id={`start${value.propId.replace(/\s/g, '')}`} value={value.startValue} classes={value.isStartEnd ? '' : 'w-full'}></SimpleDateField>
                                            {value.isStartEnd ?
                                                <SimpleDateField propid={value.propId} testid={`End-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYYY' : ''} id={`end${value.propId.replace(/\s/g, '')}`} value={value.endValue} ></SimpleDateField>
                                                : null
                                            }
                                        </div>
                                        : <div className="flex flex-row space-x-2 sm:space-x-4">
                                            <SimpleInputField propid={value.propId} testid={`Min-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Min' : ''} id={`min${value.propId.replace(/\s/g, '')}`} value={value.minValue} classes={value.isMinMax ? '' : 'w-full'}></SimpleInputField>
                                            {value.isMinMax ?
                                                <SimpleInputField propid={value.propId} testid={`Max-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Max' : ''} id={`max${value.propId.replace(/\s/g, '')}`} value={value.maxValue} ></SimpleInputField>
                                                : null
                                            }
                                        </div>}
                                </div>
                            </>
                        )
                    }) : null}
            </div>
        </>
    )
}

export default SalesFilter

